/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 30/07/13
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
    factory('User_Resource',["$resource","$location", function ($resource,$location)
    {
        var baseUrl = $location.protocol()  + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        return  $resource(baseUrl+'rest/users/:id',{}, {
            query: { method: 'GET', isArray: true },
            listAdmin: { method: 'GET', url:baseUrl+'rest/users/listAdmin',isArray: true},
            get:   { method: 'GET' },
            login: { method: 'POST', url:baseUrl+'rest/users/login'},
            loginAnonymous: { method: 'POST', url:baseUrl+'rest/users/loginAnonymous'},
            loginAsAdmin: { method: 'POST', url:baseUrl+'rest/users/loginAsAdmin'},
            loginAsGroup: { method: 'POST', url:baseUrl+'rest/users/loginAsGroup'},
            logout: { method: 'POST', url:baseUrl+'rest/users/logout'},
            createChannel: { method: 'POST', url:baseUrl+'rest/users/createChannel'},
            register: { method: 'POST', url:baseUrl+'rest/users/register'} ,
            registerAsAdmin: { method: 'POST', url:baseUrl+'rest/users/registerAsAdmin'} ,
            forgotPwd: { method: 'POST', url:baseUrl+'rest/users/forgotPwd'},
            getLoggedUser :{ method: 'GET', url:baseUrl+'rest/users/getLoggedUser'},
            getLoggedUserPayment  :{ method: 'GET', url:baseUrl+'rest/users/getLoggedUserPayment'},
            registerManagerMode   :{ method: 'POST', url:baseUrl+'rest/users/registerManagerMode'},
            ssoConnexion   :{ method: 'GET', url:baseUrl+'rest/users/sso-connexion'},
            notifyMarketPlace   :{ method: 'POST', url:baseUrl + 'rest/users/:id/notify-marketplace'},
            loginManagerMode:{ method: 'POST', url:baseUrl+'rest/users/loginManagerMode'},
            resetPassword: { method: 'POST', url:baseUrl+'rest/users/resetPassword/:companyCode'},
        });
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('User',["User_Resource","Subscription","UserData",
        function (User_Resource,Subscription,UserData)
    {
        //User inherit of $resource

        var  User = function (resource)
        {
            // Call the parent constructor
            this.id = null;
            this.firstName = "";
            this.lastName = "";
            this.phone = "";
            this.landline = "";
            this.email = "";
            this.password = "";
            this.adminPassword = "";
            this.companyCode = "";
            this.companyName = "";//creation account only
            this.companyLocaleCode= "";//creation account only
            this.companyCountryCode= "";//creation account only
            this.companyCurrencyCode= "";//creation account only
            this.companyDiscountCode= "";//creation account only
            this.companyTypeId = "";
            this.company = null;
            this.role = null;
            this.lastConnexionDate = null;
            this.lastUserAgent = null;
            this.serverIdentification = null;
            this.walletAmount = null;
            this.hasManagerPassword = false;
            this.isAutoManager = false;
            this.isManager = false;
            this.isSuperAdmin = false;
            this.legalType = true;
            this.isModel = false;
            this.userLocale = "fr-FR";

            if (resource!==undefined && resource!=null)
            {
                if (!this.id)
                    this.id = resource.id;
                this.firstName = resource.firstName;
                this.lastName = resource.lastName;
                this.phone = resource.phone;
                this.landline = resource.landline;
                this.email = resource.email;
                this.password = resource.password;
                this.adminPassword = resource.adminPassword;
                this.companyCode = resource.companyCode;
                this.offer = resource.offer;//creation account only
                this.companyName = resource.companyName;//creation account only
                this.companyManager = resource.companyManager;//creation account only
                this.companyDiscountCode  = resource.companyDiscountCode;
                this.role = resource.role;
                this.isAutoManager = resource.isAutoManager;
                this.isManager = resource.isManager;
                this.isSuperAdmin = resource.isSuperAdmin;
                this.walletAmount = resource.walletAmount;
                this.hasManagerPassword = resource.hasManagerPassword;
                this.lastUserAgent = resource.lastUserAgent;
                this.legalType = resource.legalType;
                this.companyTypeId = resource.companyTypeId;
                this.isModel = resource.isModel;
                this.userLocale = resource.userLocale;
                if(resource.currencyCode)
                    this.companyCurrencyCode = resource.currencyCode;
                if(resource.countryCode)
                    this.companyCountryCode = resource.countryCode;
                if(resource.localeCode)
                    this.companyLocaleCode = resource.localeCode;
                if (resource.lastConnexionDate)
                    this.lastConnexionDate = new Date(resource.lastConnexionDate);
                if (resource.serverIdentification)
                    this.serverIdentification = {
                        applicationId : resource.serverIdentification.applicationId,
                        version : resource.serverIdentification.version,
                        currentDate : resource.serverIdentification.currentDate ? new Date(resource.serverIdentification.currentDate) : null
                    }
            }
            UserData.add(this);
        }
        User.prototype.getObjectResource = function()
        {
            var rsUser = new User_Resource();
            rsUser.id = this.id;
            rsUser.firstName =this.firstName;
            rsUser.lastName =this.lastName;
            rsUser.phone =this.phone;
            rsUser.landline =this.landline;
            rsUser.email =this.email;
            rsUser.password = this.password;
            rsUser.companyCode = this.companyCode;
            rsUser.isAutoManager =this.isAutoManager;
            rsUser.isManager =this.isManager;
            rsUser.isSuperAdmin =this.isSuperAdmin;
            rsUser.userLocale = this.userLocale;
            return rsUser;
        }

        User.prototype.getObjectResourceForGroup = function()
        {
            var rsUser = new User_Resource();
            rsUser.id = this.id;
            rsUser.firstName =this.firstName;
            rsUser.lastName =this.lastName;
            rsUser.phone =this.phone;
            rsUser.landline =this.landline;
            rsUser.email =this.email;
            rsUser.password = this.password;
            return rsUser;
        }
        User.prototype.getLoginRequest = function()
        {
            var rsUser = new User_Resource();
            rsUser.email =this.email;
            rsUser.password = this.password;
            return rsUser;
        }
        User.prototype.getRegisterRequest = function()
        {
            var rsUser = new User_Resource();
            rsUser.firstName =this.firstName;
            rsUser.lastName =this.lastName;
            rsUser.phone =this.phone;
            rsUser.landline =this.landline;
            rsUser.email =this.email;
            rsUser.password = this.password;
            rsUser.adminPassword = this.adminPassword;
            rsUser.offer = this.offer;
            rsUser.companyName = this.companyName;
            rsUser.companyManager = this.companyManager;
            rsUser.companyDiscountCode = this.companyDiscountCode;
            rsUser.currencyCode = this.companyCurrencyCode;
            rsUser.localeCode = this.companyLocaleCode;
            rsUser.countryCode = this.companyCountryCode;
            rsUser.legalType = this.legalType;
            rsUser.companyTypeId = this.companyTypeId;
            rsUser.isModel = this.isModel;
            rsUser.userLocale = this.userLocale;
            return rsUser;
        };
        User.prototype.getId = function () {
            return this.id;
        };
        User.prototype.setId = function (id) {
            this.id = id;
        };
        User.prototype.setCompanyCode = function (companyCode) {
            this.companyCode = companyCode;
        };
        User.prototype.getEmail = function () {
            return this.email;
        };
        User.prototype.isLoggedToProduction = function () {
            return (this.serverIdentification && this.serverIdentification.applicationId == "bsiflexyprod")
        };
        User.prototype.getLastName = function () {
            return this.lastName;
        };
        User.prototype.getFirstName = function () {
            return this.firstName;
        };

        return User;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('UserSrv',["$log","User_Resource","ServerSrv","User","UserData","Company","gettextCatalog","BasicAuthRole",
        function ($log,User_Resource,ServerSrv,User,UserData,Company,gettextCatalog,BasicAuthRole)
    {
        var  userSrv = {};
        userSrv.query = function(successFunction,errorFunction)
        {
            User_Resource.query(
                {}, //params
                function (data) {   //success
                    UserData.clear() ;
                    for (var i=0;i< data.length;i++)
                        new User(data[i]);//Auto Add to CustomerData
                    if (successFunction!== undefined)
                        successFunction(UserData.users);

                },
                function (data) {   //failure
                    $log.error("User_Resource.query error");
                    $log.error(data);
                    if (errorFunction!== undefined)
                        errorFunction(data);
                });
        };
        userSrv.listAdmin = function(successFunction,errorFunction)
        {
            User_Resource.listAdmin(
                {}, //params
                function (data) {   //success
                    for (var i=0;i< data.length;i++)
                        new User(data[i]);//Auto Add to CustomerData
                    if (successFunction!== undefined)
                        successFunction(UserData.users);

                },
                function (data) {   //failure
                    $log.error("User_Resource.query error");
                    $log.error(data);
                    if (errorFunction!== undefined)
                        errorFunction(data);
                });
        };
        userSrv.save = function(user,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(userSrv.saveSync, user, successFunction, errorFunction);
        };
        userSrv.saveSync = function(user,successFunction,errorFunction)
        {
            //$timeout (function () {

            var userSrv = user.getObjectResource();
            userSrv.$save({}, //params
                function (data) {   //success
                    try{
                        user.setId(userSrv.id);
                        if (successFunction !=undefined)
                            successFunction(user);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try{
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        };
        userSrv.remove = function(user, successFunction, errorFunction)
        {
            ServerSrv.startSavingProcess(userSrv.removeSync, user, successFunction, errorFunction);
        };
        userSrv.removeSync = function(user, successFunction, errorFunction)
        {
            //$timeout (function () {

            var userSrv = user.getObjectResource();
            userSrv.$remove({id:user.id}, //params
                function (data) {
                    try{
                        if (successFunction !=undefined)
                            successFunction(user);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try{
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        };
        userSrv.login = function(user,successFunction,errorFunction)
        {
            var userSrv = user.getLoginRequest();
            userSrv.$login({}, //params
                function (data) {   //success
                    user.setId(data.userId);
                    user.setCompanyCode(data.companyCode);
                    if (successFunction !=undefined)
                        successFunction(data);
                },
                function (data) {
                    let errorMessage = gettextCatalog.getString("Echec de la connexion.");
                    if (data.status  && data.status=="401") {
                        errorMessage = gettextCatalog.getString("Email / mot de passe incorrect");
                    }
                    if (errorFunction !==undefined)
                        errorFunction(errorMessage);
                });

        };

        userSrv.loginOnForgetPwd = function(user,token,successFunction,errorFunction)
        {
            var userSrv = user.getLoginRequest();
            userSrv.forgetPwdToken = token;
            userSrv.$login({}, //params
                function (data) {   //success
                    user.setId(data.userId);
                    user.setCompanyCode(data.companyCode);
                    if (successFunction !=undefined)
                        successFunction(data);
                },
                function (data) {
                    let errorMessage = gettextCatalog.getString("Echec de la connexion.");
                    if (data.status  && data.status=="401") {
                        errorMessage = gettextCatalog.getString("Email / mot de passe incorrect");
                    }
                    if (errorFunction !== undefined)
                        errorFunction(errorMessage);
                });

        };
        userSrv.loginAnonymous = function(companyCode,successFunction,errorFunction)
        {
            var userSrv = new User_Resource();
            userSrv.companyCode = companyCode;
            userSrv.$loginAnonymous({}, //params
                function (data) {
                      if (successFunction !=undefined)
                        successFunction(data);
                },
                function (data) {
                    var errorMessage = "Echec de la connexion.";
                    if (errorFunction !=undefined)
                        errorFunction(errorMessage);
                });

        };
        userSrv.loginAsAdmin = function(user,successFunction,errorFunction)
        {
            var userSrv = user.getLoginRequest();
            userSrv.$loginAsAdmin({}, //params
                function (data) {   //success
                    user.setId(data.userId);
                    if (successFunction !=undefined)
                        successFunction(data);
                },
                function (data) {
                    let errorMessage = "Echec de la connexion.";
                    if (data.status  && data.status=="401") {
                        errorMessage = "Email / mot de passe incorrect";
                    }
                    if (errorFunction !== undefined)
                        errorFunction(errorMessage);
                });

        };
        userSrv.loginAsGroup = function(user,successFunction,errorFunction)
        {
            var userSrv = user.getLoginRequest();
            userSrv.$loginAsGroup({}, //params
                function (data) {
                    user.setId(data.userId);
                    if (successFunction !=undefined)
                        successFunction(data);
                },
                function (data) {
                    let errorMessage = gettextCatalog.getString("Echec de la connexion.");
                    if (data.status  && data.status=="401") {
                        errorMessage = gettextCatalog.getString("Email / mot de passe incorrect");
                    }
                    if (errorFunction !== undefined)
                        errorFunction(errorMessage);
                });

        };
        userSrv.logout = function(user,successFunction,errorFunction)
        {
            var userSrv = new User_Resource();
            userSrv.$logout({}, //params
                function (data) {
                    if (successFunction !=undefined)
                        successFunction(data);
                },
                function (data) {
                    var errorMessage = "Echec de la déconnexion.";
                    if (data.status )
                    {
                        if (data.status=="404")
                            errorMessage = "Ce compte n'existe pas.";
                    }
                    if (errorFunction !=undefined)
                        errorFunction(errorMessage);
                });

        };

        userSrv.loadLoggedUser = function(successFunction,errorFunction)
        {
            var userSrv = new User_Resource();

            userSrv.$getLoggedUser({}, //params
                function (data) {
                    var user = new User(data);
                    var company = new Company();
                    user.company = company;
                    company.users.push(user);
                    if (data.company) {
                        company.loadObject(data.company, true);
                    }
                    UserData.setLoggedUser(user);
                    if (successFunction !=undefined)
                        successFunction(user);
                },
                function (data) {
                    //Preserve access to FlexyBeauty.
                    var user = new User();
                    var company = new Company();
                    user.company = company;
                    company.users.push(user);
                    UserData.setLoggedUser(user);
                    if (errorFunction !=undefined)
                        errorFunction(data);
                });

        };

        userSrv.loadLoggedUserPayment = function(user,successFunction,errorFunction) {
            var userSrv = new User_Resource();
            userSrv.$getLoggedUserPayment({}, //params
                function (data) {
                    if (user.company) {
                        user.company.loadPaymentData(data);
                    }
                    if (successFunction !== undefined) {
                        successFunction(data);
                    }
                },
                function (data) {
                    if (errorFunction !== undefined) {
                        errorFunction(data);
                    }
                });
        };

        userSrv.ssoConnexion = function(successFunction, errorFunction) {
            let userSrv = new User_Resource();
            userSrv.$ssoConnexion({},
                function (data) {
                    if(successFunction !== undefined) {
                        successFunction(data);
                    }
                },
                function () {
                    if(errorFunction !== undefined) {
                        errorFunction(BasicAuthRole.LE_CISEAU_ROLE.proSite);
                    }
                });
        };

        userSrv.notifyMarketPlace = function(userId) {
            let userResource = new User_Resource();
            return userResource.$notifyMarketPlace({id: userId});
        };

        userSrv.forgotPwd = function(user,successFunction,errorFunction)
        {
            var userSrv = new User_Resource();
            userSrv.email = user.email;
            userSrv.$forgotPwd({}, //params
                function (data) {
                    if (successFunction !=undefined)
                        successFunction(data);
                },
                function (data) {
                    var forgotPasswordFailure = gettextCatalog.getString("Echec de l'oubli de mot de passe.");

                    var errorMessage = forgotPasswordFailure;
                    if (errorFunction !=undefined)
                        errorFunction(errorMessage);
                });

        };
        userSrv.registerManagerMode = function(user,password,managerPassword,successFunction,errorFunction)
        {
            var userSrv = new User_Resource();
            userSrv.password = password;
            userSrv.managerPassword = managerPassword;
            userSrv.$registerManagerMode({}, //params
                function (data) {
                    if (successFunction !=undefined)
                        successFunction(data);
                },
                function (data) {
                    var connexionFailure = gettextCatalog.getString("Echec de la connexion."),
                        passwordIncorrect = gettextCatalog.getString("Le mot de passe est incorrect."),
                        accountNotExist = gettextCatalog.getString("Ce compte n'existe pas."),
                        errorMessage = connexionFailure;

                    if (data.status )
                    {
                        if (data.status=="401") {
                            errorMessage = passwordIncorrect;
                        }
                        if (data.status=="404")
                            errorMessage = accountNotExist;

                    }
                    if (errorFunction !=undefined)
                        errorFunction(errorMessage);
                });

        };
        userSrv.loginManagerMode = function(user,managerPassword,successFunction,errorFunction)
        {
            var userSrv = new User_Resource();
            userSrv.managerPassword = managerPassword;
            userSrv.$loginManagerMode({}, //params
                function (data) {
                    if (successFunction !=undefined)
                        successFunction(data);
                },
                function (data) {
                    var connexionFailure = gettextCatalog.getString("Echec de la connexion."),
                        passwordIncorrect = gettextCatalog.getString("Le mot de passe est incorrect."),
                        accountNotExist = gettextCatalog.getString("Ce compte n'existe pas."),
                        errorMessage = connexionFailure;

                    if (data.status )
                    {
                        if (data.status=="401")
                            errorMessage = passwordIncorrect;
                        if (data.status=="404")
                            errorMessage = accountNotExist;

                    }
                    if (errorFunction !=undefined)
                        errorFunction(errorMessage);
                });

        };
        userSrv.createChannel = function() {
            return User_Resource.createChannel({}).$promise;
        };
        userSrv.register = function(user,successFunction,errorFunction)
        {
            var userSrv = user.getRegisterRequest();
            userSrv.$register({}, //params
                function (data) {   //success
                    user.setId(data.userId);
                    if (data.companyCode)
                        user.setCompanyCode(data.companyCode);
                    if (successFunction !=undefined)
                        successFunction(data);
                },
                function (data) {
                    var accountCreationImpossible = gettextCatalog.getString("Création du compte impossible."),
                        emailEverUse = gettextCatalog.getString("Cet email est déjà utilisé."),
                        companyNameEverUsed = gettextCatalog.getString("Le nom de l'entreprise est déjà utilisé."),
                        notAurizedCaracterInCompanyName = gettextCatalog.getString("Le nom de l'entreprise contient des caratères non autorisés."),
                        unknownPromoCode = gettextCatalog.getString("Le code promo n'est pas reconnu."),
                        errorMessage = accountCreationImpossible;

                    if (data.status && data.data )
                    {
                        if (data.status=="409" )
                        {
                            if (data.data.errorCode == "40901")
                                errorMessage = accountCreationImpossible + "\n" + emailEverUse;
                            if (data.data.errorCode == "40902")
                                errorMessage = accountCreationImpossible + "\n" + companyNameEverUsed;
                            if (data.data.errorCode == "40903")
                                errorMessage = accountCreationImpossible + "\n" + notAurizedCaracterInCompanyName;
                            if (data.data.errorCode == "40904")
                                errorMessage =accountCreationImpossible + "\n" + unknownPromoCode;
                        }
                    }
                    if (errorFunction !=undefined)
                        errorFunction(errorMessage);
                });

        };
        userSrv.registerAsAdmin = function(user,successFunction,errorFunction)
        {
            var userSrv = user.getRegisterRequest();
            userSrv.$registerAsAdmin({}, //params
                function (data) {   //success
                    user.setId(data.userId);
                    if (successFunction !=undefined)
                        successFunction(data);
                },
                function (data) {
                    var accountCreationImpossible = "Création du compte impossible.",
                        emailEverUse = "Cet email est déjà utilisé.",
                        errorMessage = accountCreationImpossible;
                    if (data.status && data.data )
                    {
                        if (data.status=="409" )
                        {
                            if (data.data.errorCode == "40901")
                                errorMessage = accountCreationImpossible + "\n" + emailEverUse;
                        }
                    }
                    if (errorFunction !=undefined)
                        errorFunction(errorMessage);
                });

        };

        userSrv.resetPassword = function (companyCode, successFunction, errorFunction) {
            User_Resource.resetPassword({companyCode: companyCode}, {}).$promise.then(
                (response) => {
                    if (successFunction != null) {
                        successFunction(response);
                    }
                },
                (response) => {
                    if (errorFunction != null) {
                        errorFunction(response);
                    }
                });
        }



        return userSrv;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('UserData',["$filter", function ($filter){
        var  userDataSrv = {
            loggedUser : null,
            indexUsers : [],
            activeUsers : [],
            deletedUsers : []//deleted items
        };
        userDataSrv.getById =  function(userId)
        {
            for (var i=0;i<this.indexUsers.length;i++)
                if (this.indexUsers[i].getId()==userId)
                    return this.indexUsers[i];
            return null;
        };
        userDataSrv.getByIndex =  function(index)
        {
            if (index>=0 && index <this.indexUsers.length)
                return this.indexUsers[index];
            return null;
        };
        userDataSrv.getIndexOf =  function(user)
        {
            if (user)
                return this.indexUsers.indexOf(user);
            return -1;
        };

        userDataSrv.add =  function(user)
        {
            var userArray = this.activeUsers;
            if (user.isDeleted)
                userArray =  this.deletedUsers;
            var userExist = this.getById(user.id);
            var index =  -1;
            if (userExist)
                index = userArray.indexOf(userExist);
            else
            {
                index = this.indexUsers.length
                this.indexUsers.push(user);
                userArray.push(user);
            }
            return index;
        };
        userDataSrv.remove =  function(user)
        {
            var index =  this.activeUsers.indexOf(user);
            if (index!=-1)
            {
                this.activeUsers.splice(index, 1);
                this.deletedUsers.push(user)
                user.isDeleted=true;
            }
        };
        userDataSrv.restore =  function(user)
        {
            var index =  this.deletedUsers.indexOf(user);
            if (index!=-1)
            {
                this.deletedUsers.splice(index, 1);
                this.activeUsers.push(user);
                user.isDeleted=false;
            }
        };
        userDataSrv.clear =  function()
        {
            this.indexUsers = [];
            this.activeUsers = [];
            this.deletedUsers = [];
        };
        userDataSrv.sort =  function()
        {
            this.activeUsers = $filter('orderBy')(this.activeUsers,'lastName', false);
            this.deletedUsers = $filter('orderBy')(this.deletedUsers,'lastName', false);
        };

        userDataSrv.getActiveList =  function()
        {
            return this.activeUsers;
        };
        userDataSrv.getDeletedList =  function()
        {
            return this.deletedUsers;
        };


        userDataSrv.getLoggedUser =  function()
        {
            return userDataSrv.loggedUser;
        };
        userDataSrv.setLoggedUser =  function(user)
        {
            userDataSrv.loggedUser = user;
        };

        return userDataSrv;
    }]);



// WEBPACK FOOTER //
// ./js/services/models/User.js